export const ANGEL_GUILD_PREMIUM_YEARLY_OFFER_ID = '1841'
export const ANGEL_GUILD_PREMIUM_MONTHLY_OFFER_ID = '1848'
export const ANGEL_GUILD_BASIC_MONTHLY_OFFER_ID = '1873'
export const ANGEL_GUILD_BASIC_YEARLY_OFFER_ID = '3169'
